import React from 'react';

const CustomContainer = ({ children, style = {} }) => {
    return (
        <div
            style={{
                ...style,
                border: '1px solid #f2f2f2',
                margin: '8px 0',
                borderRadius: 8,
                padding: '16px 16px',
                boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.25)',
            }}
        >
            {children}
        </div>
    );
};

export default CustomContainer;
